module.exports = __webpack_public_path__ + "static/media/teachers.27ed68c9.svg";